import sels from 'sels';
import _pick from 'lodash/pick';
import crossSearch from '@ott/utility-cross-search';
import { HOTELS_LAST_SEARCH_KEY } from '../constants';
import { Room, FormState, Destination } from '../types';

interface Options {
  hasDestination: boolean;
}

const defaultOptions: Options = {
  hasDestination: true,
};

const REQUIRED_PARAMS = ['to', 'dates', 'rooms'];

const useSave = (options: Partial<Options> = {}) => {
  const { hasDestination } = {
    ...defaultOptions,
    ...options,
  };

  const saveLastSearch = (data: FormState) => {
    const preparedParams = _pick(data, REQUIRED_PARAMS);
    sels.set(HOTELS_LAST_SEARCH_KEY, JSON.stringify(preparedParams));
  };

  const saveCrossSearch = (data: FormState) => {
    if (!hasDestination) {
      return;
    }

    /**
     * Проверка выше означает гарантию non-nullish to
     */

    const {
      dates: { endDate, startDate },
      rooms,
      to,
    } = data;

    const { lat, lng } = to as Destination;

    const { adults, childrenAges } = rooms.reduce(
      (acc: Room, room: Room) => {
        return {
          adults: acc.adults + room.adults,
          childrenAges: [...acc.childrenAges, ...room.childrenAges],
        };
      },
      { adults: 0, childrenAges: [] }
    );

    crossSearch.setHotel({
      lat,
      lng,
      dateStart: startDate,
      dateEnd: endDate,
      adults,
      childrenAges,
    });
  };

  return { saveLastSearch, saveCrossSearch };
};

export default useSave;
